import React, { useState } from "react";
import RootLayout from "./root-layout";
import MainImage from "./MainImage";
import { Link, useNavigate } from "react-router-dom";
import OTPInput from "react-otp-input";

import { toast } from "react-toastify";
import axiosInstance from "../../apiInstances/axiosInstance";

const OTPVerification = () => {
  const Email = localStorage.getItem("email");
  const nevigate = useNavigate();

  const [otp, setOtp] = useState("");

  const handleOtpChange = (value) => {
    // Remove non-digit characters from the input value
    const sanitizedValue = value.replace(/\D/g, "");
    setOtp(sanitizedValue);
  };

  const submit = async (event) => {
    event.preventDefault();
    const obj = {
      email: Email,
      otp: otp,
    };
    axiosInstance
      .post("verify_otp", obj)
      .then((response) => {
        if (response.data.status) {
          localStorage.clear("email");
          nevigate(`/companydetails/${response.data.id}`);
          toast.success(response.data.message);
          // localStorage.setItem("Token", responce.data.data.token);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((err) => console.log(err));
  };

  const resendOtp = async () => {
    const obj = {
      email: Email,
    };
    axiosInstance
      .post("resend_otp", obj)
      .then((response) => {
        if (response.data.status) {
          toast.success(response.data.message);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <RootLayout className="">
        <MainImage className="mt-8" />

        <div className="bg-white w-full max-w-xl rounded-3xl md:mt-16 mt-5 md:pt-16 p-5 flex-center flex-col ">
          <h1 className="text-regal-blue font-josefin font-bold md:text-4xl text-3xl text-center text-[#294894]">
            OTP Verification
          </h1>
          <p className="text-center text-[#414141] font-medium font-sans mt-5">
            Enter the OTP you received at your email
          </p>

          <div className="mt-6">
            <form className="space-y-4 md:space-y-6" action="#">
              <div className="flex flex-row justify-center">
                <OTPInput
                  value={otp}
                  onChange={handleOtpChange}
                  numInputs={4}
                  inputStyle="otp-style-input outline-none  caret-regal-blue py-1 rounded mx-3 text-black"
                  containerStyle={"otp-container"}
                  className="flex justify-center items-center"
                  renderInput={(props) => (
                    <input
                      {...props}
                      style={{
                        width: "50px",
                        height: "60px",
                        fontSize: "25px",
                        textAlign: "center",
                        borderRadius: "6px",
                        borderWidth: "2px",
                        boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)", // Add a shadow
                        color: "#030239",
                      }}
                    />
                  )}
                />
              </div>
            </form>

            <div
              onClick={submit}
              className="justify-center font-sans font-medium items-center flex mt-10"
            >
              <button className="bg-[#22345C] rounded-lg py-3 px-8 font-medium text-lg text-white leading-normal ">
                Verify
              </button>
            </div>

            <Link
              onClick={resendOtp}
              to=""
              className="font-medium text-[#030239]  font-sans justify-center flex mt-6 mb-2"
            >
              Resend OTP
            </Link>
          </div>
        </div>
      </RootLayout>
    </>
  );
};

export default OTPVerification;
